import { spin } from '../../utils/style';
import styled, { css } from 'styled-components';
import { Format, StyleColor } from '../../utils/styles-constants';
import { NewButton } from '../Button/styles';
import { FormFieldContainer } from '../Share/UprezForm/styles';

interface InfosFieldsProps {
	isActive: boolean;
}

const InfosFields = styled(FormFieldContainer)`
	font-weight: ${(props: InfosFieldsProps) => props.isActive ? '700' : '400'};
	width: calc(100% - 30px);
	padding: 0 15px;
	font-size: 15px;
	letter-spacing: 0.2px;
	justify-content: space-between;
	cursor: pointer;
`;

const ButtonContainer = styled('div')`
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin: auto;
	max-width: 600px;

	@media ${Format.Smartphone} {
		flex-direction: column;
	}
`;

const ParametersPageButton = styled(NewButton)`
	margin: 35px 15px 0 15px;
	width: 260px;

	@media ${Format.Smartphone} {
		margin-top: 25px;
		align-self: center;
	}
`;

const CancelButton = styled(ParametersPageButton)`${css`
	background-color: ${StyleColor.Grey500};
	border-color: ${StyleColor.Grey500};

	& > span {
		width: 50%;
	}

	& > svg {
		height: 25px;
		width: 25px;
		animation: ${spin};
	}
`}`;

const CheckboxWrapper = styled('div')`
	display: flex;
	justify-content: center;
	margin: 20px auto;

	label {
		box-sizing: border-box;
		position: relative;
		padding-left: 30px;
		font-size: 14px;
		line-height: 20px;
		color: ${StyleColor.Grey500};
		cursor: pointer;

		&::before {
			content: '';
			box-sizing: inherit;
			position: absolute;
			top: 0;
			left: 0;
			width: 20px;
			height: 20px;
			border: 2px solid currentColor;
			border-radius: 4px;
		}

		input {
			display: none;
		}

		svg {
			position: absolute;
			top: 3px;
			left: 3px;
			width: 14px;
			height: 14px;
			fill: currentColor;
		}
	}
`;

export {
	ButtonContainer,
	ParametersPageButton,
	CancelButton,
	InfosFields,
	CheckboxWrapper,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/styles.ts